export default "__VITE_ASSET__dc8bb77f__"